import React, { useContext } from 'react';
import { dataProcessing } from '../assets/dummyData/faq';
import Faq from '../components/Faq/Faq';
import { Context } from '../context/Products';
import Helmet from '../components/Helmet';
import { seo } from '../assets/dummyData/seo';

const PersonalDataProcessingPage = () => {
  const [{ lang }] = useContext(Context);
  return (
    <div id="page-faq" className="page">
        <Helmet title={seo[lang].privacy.title} metaDesc={seo[lang].privacy.description} lang={lang} />
        <Faq dataProcessing={dataProcessing[lang].parag} title={dataProcessing[lang].title} />
    </div>
  )
}

export default PersonalDataProcessingPage;
